module.exports = __webpack_public_path__ + "static/img/img_iot_pt_ys1.4118445f.png";